/**
 * KAN-304: an app-update reload tells the NEW page's static preloader (public/splash-phase.js) not to fade in
 * again — the old page already showed the splash, so the rail (and its coral dot) carries straight on instead of
 * blinking out for ~13 frames. Keep KEY and the window equal to public/splash-phase.js.
 */
export const UPDATE_RELOAD_MARKER_KEY = 'crewvex.update.reloadAt';

export function markUpdateReload(now = Date.now()) {
  try { window.sessionStorage.setItem(UPDATE_RELOAD_MARKER_KEY, String(now)); } catch (_) { /* best-effort */ }
}
